import qs from 'qs'

export const useTableFilter = (search, defaultValue = null) => {

    // Filter functionality
    const queryParams = qs.parse(search, { ignoreQueryPrefix: true })

    return queryParams["filterBy"] ? queryParams["filterBy"] : defaultValue
}